export const initialADPSettingsData = {
  export_mileage_only: '',
  enable_cost_code: '',
  use_job_code: '',
};
